import { AuthService } from './auth.service';

export const authServiceInit = (authService: AuthService) => {
	// init operazioni preliminari
	return () => authService.runInitialLoginSequence();
};
